import { c as _c } from "react/compiler-runtime";
import { Heading, Image, SimpleGrid, VStack } from '@chakra-ui/react';
import LPBlock from '@src/components/sco/LayoutBlocks/LPBlock';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React from 'react';
export const KeyStatsBlock = () => {
  const $ = _c(5);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([1, 2, 3, 5]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = iconWithHeadingContent.map(_temp);
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <LPBlock title="Key Stats" titleColor="statusSuccess" cards={[<SimpleGrid key="key-stats-block" alignContent="center" columns={t0} gap={10} justifyContent="center">{t1}</SimpleGrid>]} />;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const iconWithHeadingContent = [{
  imageSrc: '/assets/icons/accelerator/rocket.svg',
  imageAlt: 'Fundraising Icon',
  headingText: 'Over 1 Million Startups'
}, {
  imageSrc: '/assets/icons/accelerator/increas.svg',
  imageAlt: 'Startups Icon',
  headingText: '$20B Raised by our Startups'
}, {
  imageSrc: '/assets/icons/accelerator/invest.svg',
  imageAlt: 'Investors Icon',
  headingText: '$700m+ Capital Commitments'
}, {
  imageSrc: '/assets/icons/accelerator/stock market.svg',
  imageAlt: 'Investors Icon',
  headingText: '15 IPOs'
}, {
  imageSrc: '/assets/icons/accelerator/clock.svg',
  imageAlt: 'Investors Icon',
  headingText: '11+ Years of Service'
}];
const IconWithHeading: React.FC<{
  imageSrc: string;
  imageAlt: string;
  headingText: string;
  showDivider?: boolean;
}> = t0 => {
  const $ = _c(9);
  const {
    imageSrc,
    imageAlt,
    headingText,
    showDivider: t1
  } = t0;
  const showDivider = t1 === undefined ? true : t1;
  const t2 = showDivider ? "1px solid" : "none";
  let t3;
  if ($[0] !== imageAlt || $[1] !== imageSrc) {
    t3 = <Image alt={imageAlt} height={100} src={imageSrc} width={100} />;
    $[0] = imageAlt;
    $[1] = imageSrc;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== headingText) {
    t4 = <Heading color="statusSuccess" size="xl" textAlign="center">{headingText}</Heading>;
    $[3] = headingText;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = <VStack align="center" borderColor="colorPalette.border" borderRight={t2} height="full" justify="center" paddingX={10} width="full">{t3}{t4}</VStack>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
function _temp(item, index) {
  return <IconWithHeading key={`icon-with-heading-${index}`} headingText={item.headingText} imageAlt={item.imageAlt} imageSrc={item.imageSrc} showDivider={index < iconWithHeadingContent.length - 1} />;
}